export const FIRST_PAGE_OF_REVIEWS = 1;

export const RECEIVED_REVIEWS_PER_PAGE = 5;
export const MY_REVIEWS_PER_PAGE = 20;

export const RECEIVED_REVIEW_EXIT_DURATION_MS = 250;
export const MY_REVIEW_EXIT_DURATION_MS = 300;

export const MAX_ATTORNEY_NAME_LENGTH = 80;

export const MY_REVIEWS_FILTERS = ['all', 'published', 'unpublished'] as const;
export type MyReviewsFilter = (typeof MY_REVIEWS_FILTERS)[number];
